<template>
    <div class="c-form-wrap" v-bind:class="ComputedClass">
        <label class="c-form-wrap__field-name">{{label}}</label>

        <div class="c-form-wrap__field-wrap">
            <div class="c-form-wrap__input-wrap">
                <input class="c-form-wrap__input"
                       :type="type"
                       :name="fieldName"
                       :data-vv-name="fieldName"
                       v-mask="mask"
                       v-validate="vvalidate"
                       v-model="localValue"
                       :readonly="isComplete"

                       v-on:focus="focus"
                       v-on:focusout="changeField"
                       v-on:keyup.delete="replaceWithSpace">


                <div class="c-form-wrap__placeholder">{{placeholderMask}}</div>
            </div>
        </div>
        <span class="c-form-wrap__tooltip">
            <span class="c-form-wrap__hidden">
                <template v-if="isError && !focusField">
                    <template v-if="externalError.haveError">
                        {{externalError.errorText}}
                    </template>
                    <template v-else>
                        {{ errors.first(fieldName)}}
                    </template>
                </template>
                <template v-else>

                    <slot name="hint"></slot>
                </template>
            </span>
            <slot name="tooltip"></slot>
        </span>
    </div>
</template>


<script>
    import cInput from "./input";
    import {STATUSES} from "../statuses";

    export default {
        name: "cInputSmsCode",
        extends: cInput,
        props: {
            sendFunction: {
                type: Function,
                required: true
            }
        },
        data() {
            return {
                vmask: "# # # #",
                vvalidate: "min:7"
            };
        },
        methods: {
            replaceWithSpace(event) {
                this.localValue = this.localValue.substr(0, this.localValue.length - 1);
            },
            changeField(event) {
                this.$validator.validate().then(result => {
                    if (!result) {
                        //error
                    } else {
                        let valueLength = this.localValue.replace(/\s+/g, "").length;
                        if (valueLength === 4) {
                            this.sendFunction();
                        }
                    }
                });
                this.focusOut(event);
            }
        },
        watch: {
            localValue: function(newVal, oldVal){
                if(newVal !== oldVal){
                    this.$validator.validate().then(result => {
                        if (!result) {
                            //error
                        } else {
                            let valueLength = this.localValue.replace(/\s+/g, "").length;
                            if (valueLength === 4) {
                                this.sendFunction();
                            }
                        }
                    });
                }
            }
        },
        computed: {
            placeholderMask() {
                let valueLength = this.localValue.replace(/\s+/g, "").length;
                let mask = "";
                for (let i = 1; i <= 4; i++) {
                    if (i <= valueLength) {
                        mask += "   ";
                    } else {
                        mask += " _";
                    }
                }
                mask += " ";

                return mask;
            },
            isLoad:function(){
                return this.externalStatus === STATUSES.LOAD;
            },
            isLoadEnd:function(){
                return this.externalStatus === STATUSES.LOAD_END;
            },
            ComputedClass: function () {
                return {
                    "c-form-wrap--sms-code": true,
                    "c-form-wrap--empty": this.isEmpty,
                    "c-form-wrap--focus": this.isFocus,
                    "c-form-wrap--filled": this.isFilled,
                    "c-form-wrap--error": this.isError,
                    "c-form-wrap--load": this.isLoad,
                    "c-form-wrap--load-end": this.isLoadEnd,

                    "c-form-wrap--complete": this.isComplete,
                    "c-form-wrap--approve": this.isApprove,
                };
            }
        }
    };
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    .c-form-wrap.c-form-wrap--sms-code {
        $blockname: ".c-form-wrap";
        max-width: 260px;
        width: 100%;

        #{$blockname}__field-wrap {
            max-width: 140px;
            margin: 0 auto;
        }
        #{$blockname}__tooltip{
            text-align: center;
        }

        #{$blockname}__input {
            text-align: left;
            font-size: 24px;
            padding: 18px 34px 4px;
        }
        &.c-form-wrap--empty {
            #{$blockname}__field-name {
                text-align: center;
                left: 50%;
                top: 20px;
                padding: 0;
                transform: translateX(-50%);
                white-space: nowrap;
            }
            #{$blockname}__placeholder {
                display: none;
                pointer-events: none;
            }
        }
        &.c-form-wrap--focus {
            #{$blockname}__field-name {
                text-align: center;
                left: 50%;
                top: 5px;
                font-size: 12px;
                padding: 0;
                transform: translateX(-50%);
                white-space: nowrap;
            }
            #{$blockname}__placeholder {
                display: block;
                position: absolute;
                font-size: 28px;
                top: 18px;
                letter-spacing: 0px;
                left: 50%;
                white-space: nowrap;
                transform: translateX(-50%);
            }
        }
        &.c-form-wrap--filled {
            #{$blockname}__field-name {
                text-align: center;
                left: 50%;
                top: 5px;
                font-size: 12px;
                padding: 0;
                transform: translateX(-50%);
                white-space: nowrap;
            }
            #{$blockname}__placeholder {
                display: block;
                position: absolute;
                font-size: 28px;
                top: 18px;
                letter-spacing: 0px;
                left: 50%;
                white-space: nowrap;
                transform: translateX(-50%);
            }
        }
        &.c-form-wrap--filled-error {
            #{$blockname}__field-name {
                text-align: center;
                left: 50%;
                top: 5px;
                font-size: 12px;
                padding: 0;
                transform: translateX(-50%);
                white-space: nowrap;
            }
            #{$blockname}__placeholder {
                display: block;
                position: absolute;
                font-size: 28px;
                top: 18px;
                letter-spacing: 0px;
                left: 50%;
                white-space: nowrap;
                transform: translateX(-50%);
            }
        }
        &.c-form-wrap--error {
            #{$blockname}__field-name {
                color: $error;
            }
        }
        &.c-form-wrap--load,
        &.c-form-wrap--load-end {
            #{$blockname}__field-name {
                color: #d4b7d7;
                z-index: 1;
            }
            #{$blockname}__input {
                background-color: #fffefb;
                color: #b8b8b7;
                text-decoration: none;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: #d1bdcf;
                }
            }
        }
        &.c-form-wrap--load-error {
            animation: shake 0.4s 1 linear;
            #{$blockname}__field-name {
                color: $error;
            }
            #{$blockname}__input-wrap {
                &::after {
                    width: 100%;
                    background: $error;
                }
            }
            #{$blockname}__input {
                background-color: rgba(255, 78, 0, 0.12);
            }


        }
        &.c-form-wrap--complete {
            #{$blockname}__field-name {
                color: $violet;
            }
            #{$blockname}__input {
                background-color: #fffefb;
                color: #b8b8b7;
                text-decoration: none;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
        }
    }

    @keyframes shake {
        0% {
            transform: translate(30px);
        }
        20% {
            transform: translate(-30px);
        }
        40% {
            transform: translate(15px);
        }
        60% {
            transform: translate(-15px);
        }
        80% {
            transform: translate(8px);
        }
        100% {
            transform: translate(0px);
        }
    }
</style>
